<img
  src="/assets/icons/coming-soon-{{ lang() }}.svg"
  loading="lazy"
  alt="coming-soon"
  class="soon-img"
  [class.tall]="tall()"
/>
